import { Pie, PieChart } from 'recharts'
import RecapSegmentsPieLegend from './recap-segments-pie-legend'

interface RecapSegmentsPieProps {
  data: {
    name: string
    value: number
    fill: string
  }[]
}

const RecapSegmentsPie = ({ data }: RecapSegmentsPieProps) => {
  return (
    <div className="mg-store-trajectory-recap-segments-pie">
      <div className="mg-store-trajectory-recap-segments-pie-chart">
        <PieChart style={{ width: '100%', aspectRatio: 1 }} responsive>
          <Pie data={data} innerRadius="80%" outerRadius="100%" stroke="transparent" />
        </PieChart>
      </div>

      <RecapSegmentsPieLegend data={data} />
    </div>
  )
}

export default RecapSegmentsPie
